import React from 'react'
import { intl } from 'lang/intl'

import CommentReactionFormatText from '../CommentReactionFormatText/CommentReactionFormatText'

import './WebinarsChatMessageComponent.scss'

interface WebinarsChatMessageComponentProps {
  name: string
  message: string
  isSpeaker?: boolean
  onTrashClicked?: () => void
}

const WebinarsChatMessageComponent = ({
  name,
  message,
  isSpeaker = false,
  onTrashClicked,
  children,
}: React.PropsWithChildren<WebinarsChatMessageComponentProps>) => {
  const speaker = intl.formatMessage({ defaultMessage: 'Speaker' })
  const sender = `${name}${isSpeaker ? ` • ${speaker}` : ''}`

  return (
    <div
      className="webinars-chat-message"
      data-is-trash-visible={!!onTrashClicked}
    >
      {children}
      <div className="webinars-chat-message-sender">{sender}</div>
      <div className="webinars-chat-message-message">
        <CommentReactionFormatText size={16}>
          {message}
        </CommentReactionFormatText>
      </div>
    </div>
  )
}

export default WebinarsChatMessageComponent
